import { CreateTRPCProxyClient, createTRPCProxyClient, httpLink /*loggerLink*/ } from '@trpc/client';
import { TrpcAppRouterType } from 'src_server/trpc/TrpcRouter';
import { Session } from 'src_common/sdk/session';

export class TrpcClient {
    public readonly client: CreateTRPCProxyClient<TrpcAppRouterType>;

    public constructor(baseUrl: string, isBrowser: boolean, session: Session, isMobileAppInReview: boolean) {
        const client: CreateTRPCProxyClient<TrpcAppRouterType> = createTRPCProxyClient<TrpcAppRouterType>({
            links: [
                // loggerLink<TrpcAppRouterType>(),
                httpLink<TrpcAppRouterType>({
                    url: isBrowser ? '/trpc' : `${baseUrl}/trpc`,
                    fetch: (input: RequestInfo | URL, init?: RequestInit | undefined): Promise<Response> =>
                        fetch(input, init),
                    headers: () => {
                        const currentJwt = session.currentJwt;
                        const isAppInReview = isMobileAppInReview ? { 'x-app-review-token': 'app-in-review' } : {};
                        const ephemeralAuthorizationHeader =
                            session.ephemeralAccessValue === null
                                ? {}
                                : { 'x-ephemeral-authorization': session.ephemeralAccessValue.ephemeralToken.get() };

                        return {
                            Authorization: currentJwt,
                            ...isAppInReview,
                            ...ephemeralAuthorizationHeader,
                        };
                    },
                }),
            ],
        });

        this.client = client;
    }
}
